import { Box, IconButton, Typography } from "@mui/material";
import { PanelLeftOpen } from "lucide-mui";
import { useTheme } from "../context/ThemeContext";

export function TocSectionHeader({
  icon,
  title,
  subtitle,
  onToggleSidebar,
  actions,
}) {
  const { isDark } = useTheme();
  return (
    <Box
      sx={{
        mb: "8px",
        display: "flex",
        gap: "12px",
        alignItems: "flex-end",
        pt: "4px",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", gap: "12px", alignItems: "flex-start", minWidth: 0 }}>
        {onToggleSidebar && (
          <IconButton
            onClick={onToggleSidebar}
            disableRipple
            sx={{
              width: "24px",
              height: "24px",
              flexShrink: 0,
              color: isDark ? "#D5D9DF" : "#434950",
              "&:hover": { backgroundColor: "transparent" },
              "& svg": { width: "24px", height: "24px" },
            }}
          >
            <PanelLeftOpen />
          </IconButton>
        )}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {icon}
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: "28px",
                letterSpacing: "0.036px",
                color: isDark ? "#ECEFF3" : "#434950",
              }}
            >
              {title}
            </Typography>
          </Box>
          {subtitle && (
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "20px",
                color: isDark ? "#A8AEB6" : "#6A7079",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {actions ? (
        <Box sx={{ flexShrink: 0, ml: "auto" }}>{actions}</Box>
      ) : null}
    </Box>
  );
}
